import React, { Fragment } from "react";
import Chatbot from "../Chatbot";
import "./index.css";
import { Navbar as OSUNavbar } from "@osu/navbar";

export default function App() {
  return <Fragment>
      <OSUNavbar />
      <Chatbot id="page-content" className="main" component="main" />
    </Fragment>
}